'use client';

import { NotificationType } from '@/lib/types/restaurant/NotificationType';
import * as React from 'react';
import { mutate } from 'swr';
import NotificationCard from './NotificationCard';
import { cn } from '@/lib/utils';
import Pagination from '@/shared/Pagination';
import useRoutePath from '@/hooks/useRoutePath';
import useFilters from '@/hooks/useFilters';
import { notificationMarkAsRead as nfcMarkAsReadByRestaurant } from '@/clients/restaurant/notifications';
import { notificationMarkAsRead as nfcMarkAsReadByCustomer } from '@/clients/customer/notifications';
import { toastErrors } from '@/lib/helpers/functions';
import useAppLocale from '@/hooks/useAppLocale';
import useLanguageChange from '@/hooks/useLanguageChange';

export default function Notifications(props: any) {
  const {
    notificationsData,
    crFrom,
    nfcFor,
    nfcClass = '',
    nfcListClass = '',
    viewLink,
    handleClick,
    mutateKey,
  } = props;
  const { handleFilterChange } = useFilters();

  const { lang: cuslocaleLang } = useAppLocale();
  const { defaultLocale: resLocaleLang } = useLanguageChange();
  let localeLang: null | string = null;
  if (nfcFor === 'nfc_restaurant_popover' || nfcFor === 'nfc_restaurant_page') {
    localeLang = (
      resLocaleLang?.lang?.key ? resLocaleLang.lang.key : 'de'
    ) as string;
  } else {
    localeLang = cuslocaleLang;
  }

  const { router, pathname } = useRoutePath();

  const onPageChange = (params: any) => {
    console.log({ params });
    handleFilterChange(params);
    mutate([mutateKey]);
  };

  const handleView = (link: string, nfc: any) => {
    let nfcMarkAsRead: any = null;
    const isRead = nfc?.notification_infos?.[0]?.read_at || nfc?.read_at;

    if (isRead) {
      router.push(link);
      handleClick?.();
      return;
    }

    if (
      (nfcFor && nfcFor === 'nfc_restaurant_popover') ||
      pathname === '/business/dash/notifications'
    ) {
      nfcMarkAsRead = nfcMarkAsReadByRestaurant;
    } else {
      nfcMarkAsRead = nfcMarkAsReadByCustomer;
    }
    nfcMarkAsRead(nfc.id)
      .then(() => {
        mutate([mutateKey]);
        router.push(link);
        handleClick?.();
      })
      .catch(({ response }: any) => {
        if (response?.data) toastErrors(response);
      });
  };

  return (
    <>
      <div
        className={cn(
          'notifications-list flex flex-col items-start',
          crFrom === 'nfc-popover' ? 'space-y-1' : 'space-y-3',
          nfcListClass
        )}
      >
        {notificationsData?.data?.length > 0 ? (
          notificationsData.data.map((nfc: NotificationType, idx: number) => {
            const isEven = idx % 2 === 0;
            let link = nfc.data?.link ?? '';
            if (crFrom === 'nfc-popover') {
              link = viewLink;
            }
            return (
              <React.Fragment key={nfc.id}>
                {/* <Link href={link} className="w-full"> */}
                <div
                  onClick={() => handleView(link, nfc)}
                  onKeyDown={() => handleView(link, nfc)}
                  role="button"
                  className={cn(
                    'nfc-item relative w-full bg-white',
                    `${
                      isEven ? 'bg-green-500' : 'bg-blue-500'
                    } w-full bg-opacity-10`,
                    nfcClass
                  )}
                >
                  <NotificationCard
                    nfc={nfc}
                    crFrom={crFrom}
                    nfcIndex={idx}
                    viewLink={viewLink}
                    localeLang={localeLang}
                  />
                </div>
                {/* </Link> */}
              </React.Fragment>
            );
          })
        ) : (
          <div className="mt-5 w-full text-center font-medium uppercase text-gray-400">
            Empty box
          </div>
        )}
      </div>
      {crFrom !== 'nfc-popover' &&
        notificationsData?.meta?.last_page > 0 &&
        notificationsData?.meta?.total > 0 && (
          <Pagination
            totalItems={notificationsData?.meta?.total as number}
            itemsPerPage={notificationsData?.meta?.per_page || 10}
            currentPage={notificationsData?.meta?.current_page || 1}
            onPageChange={onPageChange}
          />
        )}
    </>
  );
}
